import { getMetricDataSourceByKey } from '@gonfalon/openapi/operations/getMetricDataSourceByKey';
import { getMetricDataSources } from '@gonfalon/openapi/operations/getMetricDataSources';
import { getMetricDataSourcesByAccount } from '@gonfalon/openapi/operations/getMetricDataSourcesByAccount';

import { createQueryOptions } from '../internal/createQueryOptions';

export const getMetricDataSourcesQuery = createQueryOptions(getMetricDataSources);

export const getMetricDataSourcesByAccountQuery = createQueryOptions(getMetricDataSourcesByAccount);

export const getMetricDataSourceByKeyQuery = createQueryOptions(getMetricDataSourceByKey);
